import React from "react";
import styled from "styled-components";
import Box from "react-raster";
import Container from "../Container";
import { H3, Eyebrow } from "../Typography";
import FormikForm from "./FormikForm";
import ContentArea from "../ContentArea";

const FullWidthWrapper = styled.div`
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

const ContactUsForm = ({
  title,
  successMessage,
  contentArea,
  doFocusFirstFieldOnLoad,
  eyebrow,
  hasBottomMargin,
  hasTopMargin,
}) => {
  return (
    <FullWidthWrapper
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container id="contact-form">
        <Box cols={[12, 5]} marginRight={[0, 0, 1]}>
          <ContentArea {...contentArea} />
        </Box>
        <Box cols={[12, 6]}>
          {eyebrow && (
            <Eyebrow colour={"grey"} marginBottom="16px">
              {eyebrow}
            </Eyebrow>
          )}
          <H3>{title}</H3>
          <FormikForm
            successMessage={successMessage}
            doFocusFirstFieldOnLoad={doFocusFirstFieldOnLoad}
          />
        </Box>
      </Container>
    </FullWidthWrapper>
  );
};

export default ContactUsForm;
